import { Domain, ExtendedDomainConfiguration } from '../domain-config/domain-config'
import { AgencyData } from '@/types/Misc'
import { Currency } from '@/types/Page'

export let config: ExtendedDomainConfiguration
export let testVariants: string
export let agencyData: AgencyData
export let whitelabel: boolean

export function initializeServerHelper(
  configuration: ExtendedDomainConfiguration,
  domain: Domain,
  tVariants: string,
  agencyDataParameter: AgencyData,
  whitelabelParameter: boolean,
  currency: Currency,
): void {
  config = {
    ...configuration,
    domain,
    currency,
  }
  testVariants = tVariants
  agencyData = agencyDataParameter
  whitelabel = whitelabelParameter
}
